import { CheckCircle2 } from "lucide-react";
import type { ScanCompleteEvent } from "@/types/scan-events";

interface CompletionBannerProps {
  result: ScanCompleteEvent;
}

export function CompletionBanner({ result }: CompletionBannerProps) {
  const elapsed = result.elapsedMs < 60000
    ? `${(result.elapsedMs / 1000).toFixed(0)}s`
    : `${(result.elapsedMs / 60000).toFixed(1)}m`;

  return (
    <div className="mx-3 mt-3 rounded-lg bg-green-50 dark:bg-green-950/30 border border-green-200 dark:border-green-800 p-3">
      <div className="flex items-center gap-2 text-green-700 dark:text-green-400 font-medium text-sm">
        <CheckCircle2 className="size-4" />
        Scan Complete
      </div>
      <div className="mt-1.5 grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-green-600 dark:text-green-500">
        <span>{result.totalLocations} locations</span>
        <span>{result.sportFieldsFound} sport fields</span>
        <span>${result.totalCost.toFixed(4)} cost</span>
        <span>{elapsed}</span>
      </div>
    </div>
  );
}
